import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ModuleItemProps } from "apis/module";
import { PaginationProps } from "utils/types/API";

export interface ModuleState {
    loading: boolean;
    list: {
        data: ModuleItemProps[];
        options: ModuleItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: ModuleItemProps;
    };
}

const initialState: ModuleState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: ModuleItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: ModuleItemProps;
}
export const moduleSlice = createSlice({
    name: "module",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = moduleSlice.actions;
export default moduleSlice.reducer;
